import { SafeError } from './SafeError';

export class PromiseTimeoutError extends SafeError {}

export function promiseTimeout<T>(handler: () => Promise<T>, timeout = 30000) {
  let timerId: NodeJS.Timeout;
  return Promise.race([
    handler(),
    new Promise<never>(
      (_, reject) =>
        (timerId = setTimeout(() => reject(new PromiseTimeoutError('Timeout')), timeout))
    ),
  ]).finally(() => {
    clearTimeout(timerId);
  });
}
